var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#FFC775",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10.0156C17 13.8816 13.866 17.0156 9.99997 17.0156C6.13398 17.0156 2.99997 13.8816 2.99997 10.0156C2.99997 6.14963 6.13398 3.01562 9.99997 3.01562C13.866 3.01562 17 6.14963 17 10.0156ZM10.5 6.01562C10.5 5.73948 10.2761 5.51562 10 5.51562C9.72386 5.51562 9.5 5.73948 9.5 6.01562V10.3013C9.5 10.4907 9.607 10.6639 9.77639 10.7486L12.6335 12.1771C12.8805 12.3006 13.1809 12.2005 13.3044 11.9535C13.4279 11.7065 13.3277 11.4062 13.0807 11.2827L10.5 9.99232V6.01562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockFill);
export default __webpack_public_path__ + "static/media/icon-clock-fill.c3d4ea014b129332a876e6672bb9f5fd.svg";
export { ForwardRef as ReactComponent };